<script setup lang="ts">
    import { useRoute } from 'vue-router';

    const route = useRoute();
</script>

<template>
    <h1 class="main-title">Billing</h1>

    <ul class="tabs list-unstyled">
        <li :class="{ active: route.name === 'BillingRenewals' }">
            <router-link :to="{ name: 'BillingRenewals' }">Renewal orders</router-link>
        </li>
        <li :class="{ active: route.name === 'BillingOrders' }">
            <router-link :to="{ name: 'BillingOrders' }">Orders</router-link>
        </li>
        <li :class="{ active: route.name === 'BillingInvoices' }">
            <router-link :to="{ name: 'BillingInvoices' }">Invoices</router-link>
        </li>
        <li :class="{ active: route.name === 'BillingRegisterPayment' }">
            <router-link :to="{ name: 'BillingRegisterPayment' }">Register payment</router-link>
        </li>
        <li :class="{ active: route.name === 'BillingUnresolved' }">
            <router-link :to="{ name: 'BillingUnresolved' }">Unresolved invoices</router-link>
        </li>
        <li :class="{ active: route.name === 'BillingAccountsReceivable' }">
            <router-link :to="{ name: 'BillingAccountsReceivable' }">Accounts receivable</router-link>
        </li>
        <li :class="{ active: route.name === 'BillingMonthlyReport' }">
            <router-link :to="{ name: 'BillingMonthlyReport' }">Monthly report</router-link>
        </li>
        <li :class="{ active: route.name === 'BillingNeedToPay' }">
            <router-link :to="{ name: 'BillingNeedToPay' }">Need to pay</router-link>
        </li>
        <li :class="{ active: route.name === 'BillingTransactions' }">
            <router-link :to="{ name: 'BillingTransactions' }">Transactions</router-link>
        </li>
    </ul>

    <div class="tab-content">
        <router-view />
    </div>
</template>

<script lang="ts">
    export default { name: 'Billing' };
</script>

<style></style>
